import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, ListResponse } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { BotTimezone } from './timezones.abstraction';

@Injectable({ providedIn: 'root' })
export class TimezonesApiService extends ApiService {
  isLoading$ = this._isLoading$;

  getTimezones(): Observable<ListResponse<BotTimezone>> {
    return this._httpClient.get<ListResponse<BotTimezone>>('@api/settings/bots/timezone/').pipe(
      manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$),
    );
  }
}
